<template>
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card activeCard">
      <div class="card-body">                
        <div class="d-flex align-items-start justify-content-between pointer">
          <h6 v-on:click="GoToAppointment" class="card-title flex-grow lower-line text-truncate">{{$t('MdCurrentAppointment.CurrentAppointment')}}</h6>
          <i class="mdi mdi-arrow-right-drop-circle text-corporate" v-on:click="GoToAppointment" ></i>
        </div>
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.activitytypename">
          <small>{{ $tc('Shared.AppointmentType') }}</small><br>
          <b> {{this.currentAppointmentData.activitytypename}}</b>
        </div>
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.transdate">
          <small>{{ $t('MdCurrentAppointment.StarTime') }}</small><br>
          <b>{{this.currentAppointmentData.transdate}}</b>
        </div>
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.enddate">
          <small>{{ $t('MdCurrentAppointment.EndTime') }}</small><br>
          <b>{{this.currentAppointmentData.enddate}}</b>
        </div>
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.status">
          <small>{{ $t('Shared.Status') }}</small><br>
          <b>{{this.currentAppointmentData.appointmentStatus}}</b>
        </div>
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.employee && this.currentAppointmentData.employee.firstname || this.currentAppointmentData.employee && this.currentAppointmentData.employee.lastname">
          <small>{{ $tc('Shared.Employee') }}</small><br>
          <b>{{this.currentAppointmentData.employee.firstname }} {{this.currentAppointmentData.employee.lastname }}</b>
        </div>         
        <div class="float-left col-md-4 text-muted p-item" v-if="this.currentAppointmentData.programName">
          <small>{{ $tc('Shared.Program') }}</small><br>
          <b>{{this.currentAppointmentData.programName }}</b>
        </div>
        <div class="float-left col-md-8 text-muted p-item" v-if="currentAppointmentData.zoomStartUrl != null">
          <small>{{ $t('schedule-editor.tHealth') }}</small><br />
          <a :href=currentAppointmentData.zoomStartUrl target="_blank" class="dashLink dashURL"><i class="ikon med-open-new mr-1"></i>{{ $t('schedule-editor.sMeetingNow') }} </a>
          <i class="ikon med-copy ml-2 pointer inlineIcon" v-on:click="copied()" v-b-tooltip.hover :title="tooltipCopy" @mouseover="tooltipCopy = $t('schedule-editor.cMeetingLink')"></i>
          <i class="ikon med-notify ml-2 pointer inlineIcon" v-on:click="sendReminder()" v-b-tooltip.hover :title="tooltipSendMeeting"></i>
        </div>         

      </div>
    </div>
  </div>
</template>

<script>
import SchedulerService from '@/services/schedulers.service'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
export default {
  props: {      
      ActivityId:String,
      currentAppointmentObj:Object,
      ExecuteCall:Boolean
 },
 mixins: [DBFunctions],
  data() {
    return {  
      currentAppointmentData:this.currentAppointmentObj,
      tooltipCopy: this.$t('schedule-editor.cStartM'),
      tooltipSendMeeting: this.$t('schedule-editor.sMeeInv'),  
     /*currentAppointmentData:{
      employee:{
            firstname:"",
            lastname:""
        }
     },*/
    }
  },
  
methods:{

  copied() {
      navigator.clipboard.writeText(this.currentAppointmentData.zoomStartUrl);
      this.tooltipCopy = this.$t('schedule-editor.uCopied')
  },

  async sendReminder() {
      let param = {
        activityId: this.$refs.activityId && this.$refs.activityId.value ? this.$refs.activityId.value : null,
        patientCode: this.$refs.PatientCode && this.$refs.PatientCode.value ? this.$refs.PatientCode.value : null
      }
      await SchedulerService.notifyPatientOnDemand(param)
        .then((response) => {
          if(response.status == '200' && response.data ){
            this.showMessage(this.$t('schedule-editor.sReminder'),this.$t('schedule-editor.rMsg'));
          }    
        })
        .catch((error) => {
          if (!error.response) {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
          }          
          else if(error.response.status === 400 ){
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }else if(error.response.status === 500){
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
          } else{
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }  
        });
    },

  GoToAppointment(){
    this.$router.push({ name: "Appointment-Editor", params: { id: this.$route.params.id,actId:this.$route.params.actId } }).catch(()=>{});
  },
  
  async getAppoinment(){
      this.currentAppointmentData = await this.geCurrentAppointment(this.ActivityId);	

      if (this.currentAppointmentData.transdate) {
        this.currentAppointmentData.transdate =  `${Utils.formatterDateToString(this.currentAppointmentData.transdate)} ${this.currentAppointmentData.timein}`;
      }
      if (this.currentAppointmentData.enddate) {
        this.currentAppointmentData.enddate =  `${Utils.formatterDateToString(this.currentAppointmentData.enddate)} ${this.currentAppointmentData.timeout}`; 
      }
         
      return this.currentAppointmentData;
  },
},
 mounted() {
  this.currentAppointmentData = this.ExecuteCall === true ? this.getAppoinment() : this.currentAppointmentObj; 
 }
}

</script>